module.exports = __webpack_public_path__ + "img/newRetail-upgrade3.7e2878de.png";